export default "__VITE_ASSET__DkIpFEm___"